import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Table from "../shared/table/Table";
import { FiEye, FiEdit3, FiTrash2 } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";

const InstitutionTable = () => {
  const [rows, setRows] = useState([]);
  const navigate        = useNavigate();

  const lang             = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (k, d = "") => translations[k] || d;

  /* veriyi çek */
useEffect(() => { getData(); }, []);

const getData = async () => {
  try {
    const { data } = await axios.get(
      //  1) Doğru endpoint: önce bunu deneyin
      // `${process.env.REACT_APP_API_BASE_URL}/api/institutions`,
      // Eğer backend'te /list varsa bunu kullanın:
      `${process.env.REACT_APP_API_BASE_URL}/api/institution`,
      { headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } }
    );

    //  2) Payload normalize: hem [] hem {data:[]} destekle
    const rows = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []);
    setRows(rows);
  } catch (err) {
    console.error("❌ Institution list error:", err);
    setRows([]); // tablo çökmemesi için
  }
};

  /* sil */
  const handleDelete = (id) => {
    confirmAlert({
      title: t("CONFIRM_DELETE", "Silme Onayı"),
      message: t("CONFIRM_DELETE_MSG", "Bu kurumu silmek istediğinize emin misiniz?"),
      buttons: [
        {
          label: t("YES", "Evet, sil"),
          onClick: async () => {
            try {
              await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/institution/${id}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` },
              });
              toast.success(t("DELETE_SUCCESS", "Kurum başarıyla silindi."));
              getData(); // tabloyu güncelle
            } catch (err) {
              console.error("❌ Silme hatası:", err);
              toast.error(t("DELETE_FAILED", "Silme işlemi başarısız oldu."));
            }
          },
        },
        {
          label: t("CANCEL", "İptal"),
          onClick: () => {}, // hiçbir şey yapma
        },
      ],
    });
  };
  
  /* kolonlar */
  const columns = useMemo(
    () => [
      { accessorKey: "id", header: () => "ID", size: 60 },

      {
        accessorKey: "cover",
        header: () => t("TABLE_COVER", "Görsel"),
        enableSorting: false,
        size: 120,
        cell: (info) => {
          const val = info.getValue();
          if (!val) return null;
          const src = val.startsWith("http") ? val : `${process.env.REACT_APP_API_BASE_URL}${val}`;
          return (
            <img
              src={src}
              alt="cover"
              style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 4 }}
              onError={(e) => (e.target.style.display = "none")}
            />
          );
        },
      },

      { accessorKey: "title",    header: () => t("TABLE_TITLE", "Başlık") },
     {
      id: "city",
      header: () => t("CITY", "İl"),
      cell: ({ row }) => {
        const r = row.original;
        // olası alanlar: city (string), city.name, city_name
        return r.city?.name ?? r.city_name ?? r.city ?? "-";
      },
    },
    {
      id: "district",
      header: () => t("DISTRICT", "İlçe"),
      cell: ({ row }) => {
        const r = row.original;
        // olası alanlar: district (string/obj), district.name, district_name
        return r.district?.name ?? r.district_name ?? r.district ?? "-";
      },
    },

      {
        accessorKey: "created_at",
        header: () => t("TABLE_DATE", "Tarih"),
        cell: (info) =>
          new Date(info.getValue()).toLocaleDateString("tr-TR"),
      },

      {
        accessorKey: "actions",
        header: () => t("ACTIONS", "İşlemler"),
        enableSorting: false,
        size: 140,
        cell: (info) => {
          const id = info.row.original.id;
          return (
            <div className="d-flex gap-2">
              <Link to={`/institutions/view/${id}`}
              className="avatar-text avatar-md text-primary bg-soft-primary border-soft-primary"
               title={t("VIEW", "Görüntüle")}>
                <FiEye />
              </Link>
              <Link to={`/institutions/edit/${id}`}
              className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
              title={t("EDIT", "Düzenle")}>
                <FiEdit3 />
              </Link>
              <button
                 className="avatar-text avatar-md text-danger bg-soft-danger border-soft-danger"
                title={t("DELETE", "Sil")}
                onClick={() => handleDelete(id)}
              >
                <FiTrash2 />
              </button>
            </div>
          );
        },
      },
    ],
    [translations]
  );

  return <Table data={rows} columns={columns} />;
};

export default InstitutionTable;
